import { render, staticRenderFns } from "./AddProductDetails.vue?vue&type=template&id=29d8b52e"
var script = {}
import style0 from "./AddProductDetails.vue?vue&type=style&index=0&id=29d8b52e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports